<template>
	<div ref="overlayWrapper">
		<div v-if="authStore.action == 1">
			<div v-if="this.accountInfo.HasInfoRequire">
				<div class="form-title" style="margin-bottom: 10px">Chia sẻ thông tin</div>
				<p style="
            color: #939598;
            font-family: 'BalooTamma2';
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            text-align: center;
            margin-bottom: 10px;
          ">
					Bạn đang {{ actionText }} thông tin tài khoản {{ relateAccount }} bằng MyVTC {{ username }}
				</p>
				<div class="main-form form-share-info" ref="overlayWrapper">
					<div class="info" v-if="this.accountInfo.FullName || 
					this.accountInfo.Gender || 
					this.accountInfo.BirthDay ||
					this.accountInfo.Address ||
					this.accountInfo.IdCard">
						<div v-if="this.accountInfo.FullName" class="info-group">
							<div class="info-label">Tên</div>
							<div class="info-content">{{ this.accountInfo.FullName.Value }}</div>
						</div>
						<div v-if="this.accountInfo.Gender" class="info-group">
							<div class="info-label">Giới tính</div>
							<div class="info-content">{{ this.getGender }}</div>
						</div>
						<div v-if="this.accountInfo.BirthDay" class="info-group">
							<div class="info-label">Ngày sinh</div>
							<div class="info-content">{{ this.accountInfo.BirthDay.Value }}</div>
						</div>
						<div v-if="this.accountInfo.Address" class="info-group">
							<div class="info-label">Địa chỉ</div>
							<div class="info-content">{{ this.accountInfo.Address.Value }}</div>
						</div>
						<div v-if="this.accountInfo.IdCard" class="info-group">
							<div class="info-label">Số CCCD</div>
							<div class="info-content">{{ this.accountInfo.IdCard.Value }}</div>
						</div>
					</div>
					<div class="notice">
						Bằng cách tiếp tục, bạn <span style="color: red">đồng ý</span> cho
						phép Hệ thống My VTC được truy cập và sử dụng thông tin tài khoản
						MyVTC của bạn.
					</div>

					<small class="warning" v-show="showWarning">
						<img src="@/assets/images/warning.png" alt="" />{{ textWarinng }}
					</small>
				</div>

				<a href="javascript:void(0)" class="btn-next" @click="confirmShareInfo">Tiếp theo</a>

				<a href="javascript:void(0)" class="btn-huy" style="margin-bottom: 100px" @click="cancelShareInfo">
					Hủy
				</a>
			</div>
			<div v-else>
				<div class="form-title" style="font-size: 24px; line-height: 26px; margin-bottom: 20px">
					Cập nhật thông tin tài khoản của bạn
				</div>

				<p style="
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            text-align: justify;
            max-width: 520px;
            margin: 50px auto 200px;
          ">
					Tài khoản chưa có thông tin người dùng. Vui lòng truy cập Trang
					MyAccount tại địa chỉ <br />
					<a href=""
						style="color: #248ef9; text-decoration: underline">https://myvtc.vn/myaccount</a><br />cập
					nhật thông tin để tiếp tục
				</p>
				<a href="javascript:void(0)" class="btn-next" style="margin-bottom: 20px"
					@click="redirectToMyAccount">Truy cập MyAccount</a>

				<a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="loginOtherAccount">
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
						<path
							d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
							fill="#0355CE" />
					</svg>
					Đăng nhập bằng tài khoản khác
				</a>
			</div>
		</div>
		<div v-else>
			<div class="form-title" style="margin-bottom: 35px; text-transform: unset">
				Xác thực
			</div>

			<div class="policy">
				<p>
					Bạn đang {{ actionText }} thông tin tài khoản {{ relateAccount }} bằng MyVTC {{ username }}
				</p>
			</div>
			<a href="javascript:void(0)" @click="cancelVerify()" class="btn-next" style="margin-bottom: 40px">Tôi đồng
				ý</a>

			<a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="backStep">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
					<path
						d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
						fill="#0355CE" />
				</svg>
				Quay lại
			</a>
		</div>
	</div>
</template>
<script>
import { useAuthStore, useAccountStore, useUtilsStore, useVerifyStore } from "@/store";

export default {
	data() {
		const authStore = useAuthStore();
		return {
			authStore: authStore,
			showWarning: false,
			textWarinng: "Hệ thống bận, vui lòng thử lại sau",
			accountInfo: {},
			createShareInfoRequest: {
				Address: true,
				IDCard: true,
				Code: history.state.code
			},
			actionText: authStore.action == 1 ? "xác thực" : "hủy xác thực",
			username: authStore.userInfoMyVTC.AccountName,
			relateAccount: authStore.relateAccount,
			hasInfo: false
		};
	},
	computed: {
		getGender() {
			return this.accountInfo.Gender.Value === 1 ? "Nam" : "Nữ";
		},
	},
	mounted() {
		let loader = this.$loading.show({
			// Optional parameters
			container: this.$refs.overlayWrapper,
			canCancel: false,
		});
		useAccountStore().GetAccountInfoToShare().then((result) => {
			loader.hide();
			try {
				if (result.Status) {
					this.accountInfo = result.Data;
				}
			} catch (ex) {
				console.log('ex: ' + ex);
			}
		});
	},
	methods: {
		cancelShareInfo() {
			const authStore = useAuthStore();
			authStore.logout();
			window.location.replace(`${authStore.redirectUrl}`);
		},
		loginOtherAccount() {
			const authStore = useAuthStore();
			authStore.logout();
			this.$router.push({
				name: 'username', params: {}
			});
		},
		confirmShareInfo() {
			let loader = this.$loading.show({
				// Optional parameters
				container: this.$refs.overlayWrapper,
				canCancel: false,
			});
			const authStore = useAuthStore();
			authStore.CreateShareInfo(this.createShareInfoRequest)
				.then(async (response) => {
					loader.hide();
					if (response.Status) {
						if(!await this.verify()){
							return;
						}
						if (authStore.autoRedirect === 'false') {
							this.$router.push({
								name: 'redirect',
								state: { code: response.Data.Code }
							});
							return;
						}
						useUtilsStore().redirectWithParams(`${authStore.redirectUrl}`, { code: response.Data.Code })
						return;
					}
					this.textWarinng = response.Description;
					this.showWarning = true;
				})
				.catch((error) => {
					console.error(error);
					this.textWarinng = "Hệ thống đang bận vui lòng thử lại sau";
					this.showWarning = true;
				});
		},
		async cancelVerify(){
			if(!await this.verify()){
							return;
						}
						if (this.authStore.autoRedirect === 'false') {
							this.$router.push({
								name: 'redirect',
								state: { code: history.state.code }
							});
							return;
						}
						useUtilsStore().redirectWithParams(`${this.authStore.redirectUrl}`, { code: history.state.code })
						return;
		},
		async verify() {
			let loader = this.$loading.show({
				// Optional parameters
				container: this.$refs.overlayWrapper,
				canCancel: false,
			});

			var res = await useVerifyStore().verifyAccount();
			loader.hide();
			if (res.ResponseCode > 0) {
				this.authStore.relateAccount = "";
				this.authStore.action = -1;
				return true;
			}
			else {
				this.$swal.fire({
					icon: "error",
					title: "Thông báo!",
					text: res.Description
				});
			}
			return false;
		},

		openPolicyUrl() {
			window.open(`${process.env.VUE_APP_DEFAULT_REDIRECT_URL}/chinh-sach`, '_blank');
		},
		openTermsOfUseUrl() {
			window.open(`${process.env.VUE_APP_DEFAULT_REDIRECT_URL}/dieu-khoan`, '_blank');
		},
		redirectToMyAccount() {
			window.location.replace(`${process.env.VUE_APP_DEFAULT_REDIRECT_URL}`);
		}
	},
};
</script>
<style>
.form-share-info .info {
	color: #000;
	font-family: "BalooTamma2";
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	padding: 20px 25px;
	padding-bottom: 10px;
	background: #f1f1f1;
	border-radius: 5px;
	margin-bottom: 20px;
}

.info-group {
	margin-bottom: 10px;
}

.info-label {
	color: #000;
	/* mobile-text2 */
	font-family: "BalooTamma2";
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: 30px;
	/* 150% */
	opacity: 0.5;
}

.notice {
	text-align: justify;
	line-height: 18px;
}

.notice a {
	color: #248ef9;
	text-decoration: underline;
}

.btn-next {
	margin-bottom: 15px;
}

.btn-huy {
	display: block;
	width: fit-content;
	color: #248ef9;
	margin: 0 auto;
	font-size: 20px;


}

.policy {
	width: 100%;
	max-width: 400px;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	margin: 0 auto;
	padding-right: 20px;
	margin-bottom: 40px;
}

.policy ul li {
	margin-bottom: 5px;
}

.policy p {
	margin-bottom: 10px;
}

.policy a {
	color: #0355ce !important;
	margin-bottom: 10px;
}

.policy a {
	position: relative;
}

.policy a::before {
	content: "";
	position: absolute;
	width: 100%;
	height: 1px;
	border-radius: 4px;
	background-color: #0355ce;
	bottom: 5px;
	left: 0;
	transform-origin: right;
	transform: scaleX(0);
	transition: transform 0.3s ease-in-out;
}

.policy a:hover::before {
	transform-origin: left;
	transform: scaleX(1);
}

@media(max-height: 1000px) {
	.form-bottom {
		bottom: 10px;
	}
}

/* end css 29-11-24 */


@media (max-width: 767px) {
	.info {
		max-height: 200px;
		overflow-y: scroll;
		padding-right: 5px;
	}
}

@media (max-width: 500px) {
	.info {
		max-height: 230px;
	}
}
</style>